(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frame-video-animation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const fvaVideo = document.querySelectorAll('.fva-section .fva-video-wrapper');
    let fvaTargetVideo = null;
    for (const i of fvaVideo) {
      if (window.getComputedStyle(i).display == 'block') {
        fvaTargetVideo = i.querySelector('video-media video');
      }
    }
    if (fvaTargetVideo) {

      let fvaLastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      let fvaScrollTimeout;
      let fvaScrollDirection = null; // 'up' 或 'down'
      let fvaFrameNumber; // 当前帧数

      let fvaFirstByteTime = 1
      if (document.querySelector('.fva-section .fva-first-time').value) {
        fvaFirstByteTime = Number(document.querySelector('.fva-section .fva-first-time').value);
      }

      window.addEventListener('scroll', () => {
        clearTimeout(fvaScrollTimeout); // 清除之前的定时器
        // 获取当前滚动位置
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        // 判断滚动方向
        if (currentScrollPosition > fvaLastScrollPosition) {
          fvaScrollDirection = 'down';
        } else {
          fvaScrollDirection = 'up';
        }
        fvaLastScrollPosition = currentScrollPosition; // 更新最后滚动位置
        // 设置新的定时器
        fvaScrollTimeout = setTimeout(function () {
          const rect = fvaTargetVideo.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const videoCenter = (rect.top + rect.bottom) / 2;
          // 检测视频位于窗口中
          if (videoCenter >= 0 && videoCenter <= windowHeight) {
            // 视频在屏幕内
            if (fvaScrollDirection === 'down') {
              if(fvaTargetVideo.paused) {
                fvaTargetVideo.play();
              }
            }
            if (fvaScrollDirection === 'up') {
              fvaTargetVideo.pause()
              if (fvaTargetVideo.currentTime > 0 && fvaTargetVideo.currentTime < fvaFirstByteTime) {
                fvaTargetVideo.currentTime = 0
              }
              if (fvaTargetVideo.currentTime > fvaFirstByteTime && fvaTargetVideo.currentTime < fvaTargetVideo.duration) {
                fvaTargetVideo.currentTime = fvaFirstByteTime
              }
            }
          }
          favHandleFrameNumber(fvaFrameNumber, fvaTargetVideo);
        }, 100);
      });

      fvaTargetVideo.addEventListener('timeupdate', function () {
            let fvaVideoTime = fvaTargetVideo.currentTime;
            if(fvaVideoTime == 0) {
              fvaFrameNumber = 0;
            } else if (fvaVideoTime>0 && fvaVideoTime < fvaFirstByteTime) {
                // 起始
                fvaFrameNumber = 1;
            } else if (fvaVideoTime == fvaFirstByteTime) {
                // 第一帧
                fvaFrameNumber = 2;
            }else if (fvaVideoTime > fvaFirstByteTime && fvaVideoTime < fvaTargetVideo.duration) {
                // 第二帧
                fvaFrameNumber = 3;
            } else if (fvaVideoTime ==  fvaTargetVideo.duration) {
                // 第三帧
                fvaFrameNumber = 4;
            }
            favHandleFrameNumber(fvaFrameNumber, fvaTargetVideo);
        });
    }
  });

  function favHandleFrameNumber(frameNumber, fvaTargetVideo) {
    const fvaTopText = fvaTargetVideo.closest('.shopify-section--frame-video-animation').querySelectorAll('.fva-top-wrapper .fva-top-text');
    switch (frameNumber) {

      case 0:
        // 0s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;
      case 1:
        // 0-1s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 1;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;

      case 2:
        // 1s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 1;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;

      case 3:
        // 1-播放结束
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 1;
        fvaTopText[1].style.height = 0;
        fvaTopText[2].style.height = 48 + 'px';
        break;

      case 4:
        // 播放结束
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 1;
        fvaTopText[1].style.height = 0;
        fvaTopText[2].style.height = 48 + 'px';
        break;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-bundle-showcase-single-btn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.springInit1b === '1') return;
      section.dataset.springInit1b = '1';

      var autoplay = section.dataset.autoplay === 'true';
      var imgDurationMs = parseInt(section.dataset.imgDuration || '3', 10) * 1000;
      var mobileFirst = section.dataset.mobileFirst === 'image' ? 'image' : 'video';

      var media = section.querySelector('[data-spring-media]');
      if (!media) return;

      var videoSlide = media.querySelector('.spring-bundle-1b__slide--video');
      var video = videoSlide ? videoSlide.querySelector('video') : null;
      var playBtn = videoSlide ? videoSlide.querySelector('.spring-bundle-1b__play-btn') : null;
      var bundleImgSlides = Array.from(media.querySelectorAll('.spring-bundle-1b__slide--bundle-img'));
      var progressBar = media.querySelector('.spring-bundle-1b__progress');

      var tabsBar = section.querySelector('.spring-bundle-1b__tabs');
      var tabs = Array.from(section.querySelectorAll('.spring-bundle-1b__tab'));
      var panelsWrap = section.querySelector('.spring-bundle-1b__panels');
      var panels = Array.from(section.querySelectorAll('.spring-bundle-1b__panel'));

      var activeBundleIdx = 0;
      var imgTimer = null;
      var onImageSlide = false;
      var isMobile = window.innerWidth < 990;
      var hasUserInteracted = autoplay;

      /* ---- Progress segment order follows the "which shows first" setting ---- */
      var videoProgressIdx = mobileFirst === 'image' ? 1 : 0;
      var imageProgressIdx = mobileFirst === 'image' ? 0 : 1;

      /* ---- Center the active tab inside the scrollable strip ---- */
      function centerTab(tab) {
        if (!tabsBar || !tab) return;
        // Only the tab strip scrolls horizontally — never moves the page.
        var target = tab.offsetLeft - (tabsBar.clientWidth / 2) + (tab.offsetWidth / 2);
        var max = tabsBar.scrollWidth - tabsBar.clientWidth;
        if (target < 0) target = 0;
        if (target > max) target = max;
        if (typeof tabsBar.scrollTo === 'function') {
          tabsBar.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          tabsBar.scrollLeft = target;
        }
      }

      /* ---- Equalize panel heights ----
         Measure every bundle panel (including the hidden ones) and lock the
         panels container to the tallest. On desktop the media stretches to
         the card's height, so a fixed panel height keeps the video size
         constant no matter which tab is selected. */
      function measurePanelHeight(panel) {
        var s = panel.style;
        var saved = {
          minHeight: s.minHeight, display: s.display, position: s.position,
          left: s.left, right: s.right, top: s.top, visibility: s.visibility
        };
        // render off-flow at the real column width so wrapping matches
        s.minHeight = '';
        s.display = 'flex';
        s.position = 'absolute';
        s.left = '0';
        s.right = '0';
        s.top = '0';
        s.visibility = 'hidden';
        var h = panel.offsetHeight;
        s.minHeight = saved.minHeight;
        s.display = saved.display;
        s.position = saved.position;
        s.left = saved.left;
        s.right = saved.right;
        s.top = saved.top;
        s.visibility = saved.visibility;
        return h;
      }

      function equalizePanels() {
        if (!panelsWrap || panels.length < 2) return;
        // mobile stacks naturally and the media has a fixed aspect ratio,
        // so the equal-height lock is only needed on desktop
        if (isMobile) { panelsWrap.style.minHeight = ''; return; }
        var max = 0;
        panels.forEach(function (p) {
          var h = measurePanelHeight(p);
          if (h > max) max = h;
        });
        panelsWrap.style.minHeight = max ? max + 'px' : '';
      }

      // re-measure once async content (packlist images, fonts) settles
      function scheduleEqualize() {
        if (window.requestAnimationFrame) {
          requestAnimationFrame(function () { requestAnimationFrame(equalizePanels); });
        } else {
          equalizePanels();
        }
      }

      section.querySelectorAll('.spring-bundle-1b__panel img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleEqualize);
      });
      window.addEventListener('load', scheduleEqualize);

      /* ---- Progress dots ---- */
      function buildProgress() {
        if (!progressBar) return;
        progressBar.innerHTML = '';
        if (!isMobile) return;
        // Order matches the first-shown media: image-first → [Image, Video]
        var segments = mobileFirst === 'image'
          ? [
              { label: 'Product image', show: mobileShowImage },
              { label: 'Video', show: mobileShowVideo }
            ]
          : [
              { label: 'Video', show: mobileShowVideo },
              { label: 'Product image', show: mobileShowImage }
            ];
        segments.forEach(function (seg, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'spring-bundle-1b__progress-seg' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', seg.label);
          btn.addEventListener('click', seg.show);
          progressBar.appendChild(btn);
        });
      }

      function updateProgress(idx) {
        if (!progressBar) return;
        progressBar.querySelectorAll('.spring-bundle-1b__progress-seg').forEach(function (s, k) {
          s.classList.toggle('is-active', k === idx);
        });
      }

      /* ---- Mobile swiper ---- */
      function mobileShowVideo() {
        clearTimeout(imgTimer);
        onImageSlide = false;
        bundleImgSlides.forEach(function (s) { s.classList.remove('is-active'); });
        if (videoSlide) videoSlide.classList.add('is-active');
        updateProgress(videoProgressIdx);
        if (video && hasUserInteracted) { video.currentTime = 0; video.play().catch(function () {}); }
      }

      function mobileShowImage() {
        clearTimeout(imgTimer);
        onImageSlide = true;
        if (videoSlide) videoSlide.classList.remove('is-active');
        bundleImgSlides.forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.bundleImg, 10) === activeBundleIdx);
        });
        updateProgress(imageProgressIdx);
        imgTimer = setTimeout(mobileShowVideo, imgDurationMs);
      }

      /* ---- Show the configured first media (and restart the cycle) ---- */
      function mobileShowFirst() {
        if (mobileFirst === 'image') mobileShowImage();
        else mobileShowVideo();
      }

      /* ---- Touch swipe (mobile): left = next, right = previous ----
         Two media states only (video / image); order follows mobileFirst. */
      var swipeOrder = mobileFirst === 'image' ? ['image', 'video'] : ['video', 'image'];
      var touchStartX = 0, touchStartY = 0, touchTracking = false;
      var SWIPE_THRESHOLD = 40; // px of horizontal travel needed to count as a swipe

      function goToMedia(key) {
        if (key === 'image') mobileShowImage();
        else mobileShowVideo();
      }

      if (media) {
        media.addEventListener('touchstart', function (e) {
          if (!isMobile || e.touches.length !== 1) { touchTracking = false; return; }
          touchTracking = true;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });

        media.addEventListener('touchend', function (e) {
          if (!touchTracking) return;
          touchTracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          // ignore taps and mostly-vertical gestures (let the page scroll)
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;
          var curKey = onImageSlide ? 'image' : 'video';
          var idx = swipeOrder.indexOf(curKey);
          var nextIdx = dx < 0 ? idx + 1 : idx - 1; // swipe left → next, right → prev
          if (nextIdx < 0) nextIdx = 0;
          if (nextIdx > swipeOrder.length - 1) nextIdx = swipeOrder.length - 1;
          if (nextIdx === idx) return;
          hasUserInteracted = true; // a swipe counts as user intent (lets video play)
          goToMedia(swipeOrder[nextIdx]);
        }, { passive: true });
      }

      /* ---- Tab switch ---- */
      function switchBundle(idx) {
        activeBundleIdx = idx;
        tabs.forEach(function (t) {
          var active = parseInt(t.dataset.bundleIndex, 10) === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) centerTab(t);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', parseInt(p.dataset.bundleIndex, 10) === idx);
        });
        // On mobile, switching bundles restarts the media cycle from the
        // configured first slide — and the shared video plays from the start.
        if (isMobile) {
          mobileShowFirst();
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          switchBundle(parseInt(tab.dataset.bundleIndex, 10));
        });
      });

      /* ---- Play button ---- */
      if (playBtn && video) {
        playBtn.addEventListener('click', function () {
          hasUserInteracted = true;
          video.play().catch(function () {});
          playBtn.style.display = 'none';
        });
        video.addEventListener('play', function () {
          playBtn.style.display = 'none';
        });
      }

      /* ---- Video ended ---- */
      if (video) {
        video.addEventListener('ended', function () {
          if (isMobile) {
            mobileShowImage();
          } else {
            video.currentTime = 0;
            video.play().catch(function () {});
          }
        });
      }

      /* ---- Setup for current viewport ---- */
      function setupMode() {
        isMobile = window.innerWidth < 990;
        buildProgress();
        clearTimeout(imgTimer);
        onImageSlide = false;
        if (isMobile) {
          mobileShowFirst();
        } else {
          if (videoSlide) videoSlide.classList.add('is-active');
          bundleImgSlides.forEach(function (s) { s.classList.remove('is-active'); });
          if (video && autoplay) { video.play().catch(function () {}); }
        }
        // keep the active tab visible after a layout change
        var activeTab = tabs[activeBundleIdx];
        if (activeTab) centerTab(activeTab);
        scheduleEqualize();
      }

      setupMode();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var wasMobile = isMobile;
          isMobile = window.innerWidth < 990;
          if (wasMobile !== isMobile) setupMode();
          else equalizePanels(); // width changed → text rewraps → re-lock height
        }, 200);
      });
    }

    function initAll() {
      document.querySelectorAll('.spring-bundle-1b').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.spring-bundle-1b');
      if (s) initSection(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.springInit === '1') return;
      section.dataset.springInit = '1';

      var autoplay = section.dataset.autoplay === 'true';
      var imgDurationMs = parseInt(section.dataset.imgDuration || '3', 10) * 1000;
      var mobileFirst = section.dataset.mobileFirst === 'image' ? 'image' : 'video';

      var media = section.querySelector('[data-spring-media]');
      if (!media) return;

      var videoSlide = media.querySelector('.spring-bundle__slide--video');
      var video = videoSlide ? videoSlide.querySelector('video') : null;
      var playBtn = videoSlide ? videoSlide.querySelector('.spring-bundle__play-btn') : null;
      var bundleImgSlides = Array.from(media.querySelectorAll('.spring-bundle__slide--bundle-img'));
      var progressBar = media.querySelector('.spring-bundle__progress');

      var tabsBar = section.querySelector('.spring-bundle__tabs');
      var tabs = Array.from(section.querySelectorAll('.spring-bundle__tab'));
      var panelsWrap = section.querySelector('.spring-bundle__panels');
      var panels = Array.from(section.querySelectorAll('.spring-bundle__panel'));

      var activeBundleIdx = 0;
      var imgTimer = null;
      var onImageSlide = false;
      var isMobile = window.innerWidth < 990;
      var hasUserInteracted = autoplay;

      /* ---- Progress segment order follows the "which shows first" setting ---- */
      var videoProgressIdx = mobileFirst === 'image' ? 1 : 0;
      var imageProgressIdx = mobileFirst === 'image' ? 0 : 1;

      /* ---- Center the active tab inside the scrollable strip ---- */
      function centerTab(tab) {
        if (!tabsBar || !tab) return;
        // Only the tab strip scrolls horizontally — never moves the page.
        var target = tab.offsetLeft - (tabsBar.clientWidth / 2) + (tab.offsetWidth / 2);
        var max = tabsBar.scrollWidth - tabsBar.clientWidth;
        if (target < 0) target = 0;
        if (target > max) target = max;
        if (typeof tabsBar.scrollTo === 'function') {
          tabsBar.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          tabsBar.scrollLeft = target;
        }
      }

      /* ---- Equalize panel heights ----
         Measure every bundle panel (including the hidden ones) and lock the
         panels container to the tallest. On desktop the media stretches to
         the card's height, so a fixed panel height keeps the video size
         constant no matter which tab is selected. */
      function measurePanelHeight(panel) {
        var s = panel.style;
        var saved = {
          minHeight: s.minHeight, display: s.display, position: s.position,
          left: s.left, right: s.right, top: s.top, visibility: s.visibility
        };
        // render off-flow at the real column width so wrapping matches
        s.minHeight = '';
        s.display = 'flex';
        s.position = 'absolute';
        s.left = '0';
        s.right = '0';
        s.top = '0';
        s.visibility = 'hidden';
        var h = panel.offsetHeight;
        s.minHeight = saved.minHeight;
        s.display = saved.display;
        s.position = saved.position;
        s.left = saved.left;
        s.right = saved.right;
        s.top = saved.top;
        s.visibility = saved.visibility;
        return h;
      }

      function equalizePanels() {
        if (!panelsWrap || panels.length < 2) return;
        // mobile stacks naturally and the media has a fixed aspect ratio,
        // so the equal-height lock is only needed on desktop
        if (isMobile) { panelsWrap.style.minHeight = ''; return; }
        var max = 0;
        panels.forEach(function (p) {
          var h = measurePanelHeight(p);
          if (h > max) max = h;
        });
        panelsWrap.style.minHeight = max ? max + 'px' : '';
      }

      // re-measure once async content (packlist images, fonts) settles
      function scheduleEqualize() {
        if (window.requestAnimationFrame) {
          requestAnimationFrame(function () { requestAnimationFrame(equalizePanels); });
        } else {
          equalizePanels();
        }
      }

      section.querySelectorAll('.spring-bundle__panel img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleEqualize);
      });
      window.addEventListener('load', scheduleEqualize);

      /* ---- Progress dots ---- */
      function buildProgress() {
        if (!progressBar) return;
        progressBar.innerHTML = '';
        if (!isMobile) return;
        // Order matches the first-shown media: image-first → [Image, Video]
        var segments = mobileFirst === 'image'
          ? [
              { label: 'Product image', show: mobileShowImage },
              { label: 'Video', show: mobileShowVideo }
            ]
          : [
              { label: 'Video', show: mobileShowVideo },
              { label: 'Product image', show: mobileShowImage }
            ];
        segments.forEach(function (seg, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'spring-bundle__progress-seg' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', seg.label);
          btn.addEventListener('click', seg.show);
          progressBar.appendChild(btn);
        });
      }

      function updateProgress(idx) {
        if (!progressBar) return;
        progressBar.querySelectorAll('.spring-bundle__progress-seg').forEach(function (s, k) {
          s.classList.toggle('is-active', k === idx);
        });
      }

      /* ---- Mobile swiper ---- */
      function mobileShowVideo() {
        clearTimeout(imgTimer);
        onImageSlide = false;
        bundleImgSlides.forEach(function (s) { s.classList.remove('is-active'); });
        if (videoSlide) videoSlide.classList.add('is-active');
        updateProgress(videoProgressIdx);
        if (video && hasUserInteracted) { video.currentTime = 0; video.play().catch(function () {}); }
      }

      function mobileShowImage() {
        clearTimeout(imgTimer);
        onImageSlide = true;
        if (videoSlide) videoSlide.classList.remove('is-active');
        bundleImgSlides.forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.bundleImg, 10) === activeBundleIdx);
        });
        updateProgress(imageProgressIdx);
        imgTimer = setTimeout(mobileShowVideo, imgDurationMs);
      }

      /* ---- Show the configured first media (and restart the cycle) ---- */
      function mobileShowFirst() {
        if (mobileFirst === 'image') mobileShowImage();
        else mobileShowVideo();
      }

      /* ---- Touch swipe (mobile): left = next, right = previous ----
         Two media states only (video / image); order follows mobileFirst. */
      var swipeOrder = mobileFirst === 'image' ? ['image', 'video'] : ['video', 'image'];
      var touchStartX = 0, touchStartY = 0, touchTracking = false;
      var SWIPE_THRESHOLD = 40; // px of horizontal travel needed to count as a swipe

      function goToMedia(key) {
        if (key === 'image') mobileShowImage();
        else mobileShowVideo();
      }

      if (media) {
        media.addEventListener('touchstart', function (e) {
          if (!isMobile || e.touches.length !== 1) { touchTracking = false; return; }
          touchTracking = true;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });

        media.addEventListener('touchend', function (e) {
          if (!touchTracking) return;
          touchTracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          // ignore taps and mostly-vertical gestures (let the page scroll)
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;
          var curKey = onImageSlide ? 'image' : 'video';
          var idx = swipeOrder.indexOf(curKey);
          var nextIdx = dx < 0 ? idx + 1 : idx - 1; // swipe left → next, right → prev
          if (nextIdx < 0) nextIdx = 0;
          if (nextIdx > swipeOrder.length - 1) nextIdx = swipeOrder.length - 1;
          if (nextIdx === idx) return;
          hasUserInteracted = true; // a swipe counts as user intent (lets video play)
          goToMedia(swipeOrder[nextIdx]);
        }, { passive: true });
      }

      /* ---- Tab switch ---- */
      function switchBundle(idx) {
        activeBundleIdx = idx;
        tabs.forEach(function (t) {
          var active = parseInt(t.dataset.bundleIndex, 10) === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) centerTab(t);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', parseInt(p.dataset.bundleIndex, 10) === idx);
        });
        // On mobile, switching bundles restarts the media cycle from the
        // configured first slide — and the shared video plays from the start.
        if (isMobile) {
          mobileShowFirst();
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          switchBundle(parseInt(tab.dataset.bundleIndex, 10));
        });
      });

      /* ---- Play button ---- */
      if (playBtn && video) {
        playBtn.addEventListener('click', function () {
          hasUserInteracted = true;
          video.play().catch(function () {});
          playBtn.style.display = 'none';
        });
        video.addEventListener('play', function () {
          playBtn.style.display = 'none';
        });
      }

      /* ---- Video ended ---- */
      if (video) {
        video.addEventListener('ended', function () {
          if (isMobile) {
            mobileShowImage();
          } else {
            video.currentTime = 0;
            video.play().catch(function () {});
          }
        });
      }

      /* ---- Setup for current viewport ---- */
      function setupMode() {
        isMobile = window.innerWidth < 990;
        buildProgress();
        clearTimeout(imgTimer);
        onImageSlide = false;
        if (isMobile) {
          mobileShowFirst();
        } else {
          if (videoSlide) videoSlide.classList.add('is-active');
          bundleImgSlides.forEach(function (s) { s.classList.remove('is-active'); });
          if (video && autoplay) { video.play().catch(function () {}); }
        }
        // keep the active tab visible after a layout change
        var activeTab = tabs[activeBundleIdx];
        if (activeTab) centerTab(activeTab);
        scheduleEqualize();
      }

      setupMode();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var wasMobile = isMobile;
          isMobile = window.innerWidth < 990;
          if (wasMobile !== isMobile) setupMode();
          else equalizePanels(); // width changed → text rewraps → re-lock height
        }, 200);
      });

      /* ---- Add to cart ---- */
      section.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          var variantId = btn.dataset.variantId;
          var quantity = parseInt(btn.dataset.quantity || '1', 10);
          if (!variantId) return;
          var labelEl = btn.querySelector('[data-cart-label]');
          var originalLabel = labelEl ? labelEl.textContent : btn.textContent;

          btn.disabled = true;
          if (labelEl) labelEl.textContent = 'Adding…';

          try {
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
            });
            if (!res.ok) {
              var err = await res.json().catch(function () { return {}; });
              throw new Error(err.description || err.message || 'Add to cart failed');
            }

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { variantId: variantId } }));
            var drawer = document.querySelector('cart-drawer, cart-notification');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
              document.documentElement.dispatchEvent(new CustomEvent('dialog:open', { bubbles: true, detail: { name: 'cart-drawer' } }));
            }

            if (labelEl) labelEl.textContent = 'Added ✓';
            setTimeout(function () { if (labelEl) labelEl.textContent = originalLabel; }, 1500);
          } catch (e) {
            console.error('[spring-bundle]', e);
            if (labelEl) labelEl.textContent = 'Try again';
            setTimeout(function () { if (labelEl) labelEl.textContent = originalLabel; }, 1500);
          } finally {
            btn.disabled = false;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.spring-bundle').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.spring-bundle');
      if (s) initSection(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
